import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';

import { Observable, startWith, Subject, switchMap } from 'rxjs';

import { ButtonTheme } from '@fcom/ui-components/components/buttons';
import { CorporateService } from '@fcom/common/services/corporate/corporate.service';
import { finShare } from '@fcom/rx/operators/finShare';

import { SafTermsComponent } from './saf-terms.component';

@Component({
  selector: 'fin-saf-widget',
  templateUrl: './saf-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SafWidgetComponent implements OnInit {
  protected readonly ButtonTheme = ButtonTheme;

  @ViewChild('safTerms') safTerms: SafTermsComponent;

  hasSafPermission$: Observable<boolean>;
  termsUpdated$ = new Subject();
  loading = false;

  constructor(private corporateService: CorporateService) {}

  ngOnInit(): void {
    this.hasSafPermission$ = this.termsUpdated$.pipe(
      startWith(undefined),
      switchMap(() => this.corporateService.hasActivatedSAF()),
      finShare()
    );
  }

  goToReadMore(): void {
    console.log('Read more clicked');
  }

  goToChooose(): void {
    this.loading = true;
    this.safTerms.checkTermsAndRedirect();
  }

  termsUpdated(): void {
    this.termsUpdated$.next(undefined);
    this.loading = false;
  }
}
